enum GTMEventCategory {
  ColorIcon = 'color-icon',
}

export default GTMEventCategory;
